'use client';

import React from 'react';
import { Search, FileText, Download, Plus } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface ClientsFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onOpenSelectedProfile: () => void;
  onOpenImport: () => void;
  onOpenNewClient: () => void;
  hasSelectedClient: boolean;
}

export default function ClientsFilterBar({
  searchTerm,
  onSearchChange,
  onOpenSelectedProfile,
  onOpenImport,
  onOpenNewClient,
  hasSelectedClient
}: ClientsFilterBarProps) {
  return (
    <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3">
      {/* Buscador */}
      <div className="relative flex-1 max-w-md">
        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
          <Search className="w-4 h-4" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por nombre, teléfono o email..."
          className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/90 rounded-xl text-xs md:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#6255F5]/20 focus:border-[#6255F5] shadow-xs transition"
        />
      </div>

      {/* Botones de Acción */}
      <div className="flex items-center gap-2 self-end md:self-center">
        <Button
          variant="outline"
          size="sm"
          onClick={onOpenSelectedProfile}
          disabled={!hasSelectedClient}
          title="Ver ficha 360° del cliente seleccionado"
        >
          <FileText className="w-3.5 h-3.5" />
          <span>Ficha 360°</span>
        </Button>

        <Button
          variant="outline"
          size="sm"
          onClick={onOpenImport}
          title="Exportar base de clientes"
        >
          <Download className="w-3.5 h-3.5" />
          <span>Exportar</span>
        </Button>
      </div>
    </div>
  );
}
